
const TerraceIco = ({fill}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73024 3.54267C5.8314 3.44151 5.8314 3.26448 5.73024 3.15068C5.62908 3.04952 5.45205 3.04952 5.33825 3.15068L4.89568 3.59325C4.79452 3.69441 4.79452 3.87143 4.89568 3.98524C4.94626 4.03582 5.02213 4.06111 5.08535 4.06111C5.14858 4.06111 5.22445 4.03582 5.27502 3.98524L5.73024 3.54267Z"
        fill={fill}
      />
      <path
        d="M6.7039 3.56796C6.60274 3.4668 6.42571 3.4668 6.31191 3.56796L5.31296 4.5669C5.2118 4.66806 5.2118 4.84509 5.31296 4.9589C5.36354 5.00947 5.43941 5.03476 5.50263 5.03476C5.5785 5.03476 5.64173 5.00947 5.69231 4.9589L6.69125 3.95995C6.80506 3.84615 6.80506 3.68176 6.7039 3.56796Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.07376 1.89999C3.82886 1.89999 3.63235 2.0965 3.63235 2.34141V8.85468H2.34141C2.09651 8.85468 1.9 9.05119 1.9 9.29609C1.9 9.541 2.09651 9.73751 2.34141 9.73751H3.00011V13.2172H2.34141C2.09651 13.2172 1.9 13.4137 1.9 13.6586C1.9 13.9035 2.09651 14.1 2.34141 14.1H13.3172C13.5621 14.1 13.7586 13.9035 13.7586 13.6586C13.7586 13.4239 13.5596 13.2298 13.3172 13.2298H12.6585V9.75015H13.3172C13.5621 9.75015 13.7586 9.55364 13.7586 9.30874C13.7586 9.06384 13.5621 8.86733 13.3172 8.86733H12.0262V2.34141C12.0262 2.0965 11.8297 1.89999 11.5848 1.89999H4.07376ZM4.51518 8.85468V2.78282H7.38788V8.85468H4.51518ZM8.27071 8.86733V2.78282H11.1434V8.86733H8.27071ZM3.88293 13.2298V9.75015H5.18767V13.2298H3.88293ZM6.08314 13.2298V9.75015H7.38788V13.2298H6.08314ZM8.27071 13.2298V9.75015H9.57545V13.2298H8.27071ZM10.4709 13.2298V9.75015H11.7757V13.2298H10.4709Z"
        fill={fill}
      />
    </svg>
  );
};

export default TerraceIco;
